import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LogoutShortcutListener = () => {
  const navigate = useNavigate();
 
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.altKey && e.key.toLowerCase() === 'u') {
        // نفّذ تسجيل الخروج هنا
        
         localStorage.clear();
    sessionStorage.clear();
    
    
        console.log('Logging out...');
        localStorage.removeItem('token'); // مثال لحذف التوكن
        navigate('/login'); // إعادة التوجيه لصفحة تسجيل الدخول
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate]);

  return null; // لا تحتاج إلى عرض أي شيء في هذا الكمبوننت
};

export default LogoutShortcutListener;
